import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Air, Download } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { Tooltip } from "@air/primitive-tooltip";
import { useBreakpointsContext } from "@air/provider-media-query";
import { memo, useCallback } from "react";
import { useSelector } from "react-redux";
import { ToggleNestedItemsButton } from "~/_components/ToggleNestedItemsButton";
import { usePublicPermissions } from "~/components/PublicPermissionsProvider";
import { PublicBoardStats } from "~/components/v2/components/board/PublicBoardStats";
import { BoardBottombar } from "~/components/v2/components/board/shared/BoardBottombar";
import { useIsSearchActive } from "~/hooks/search/useIsSearchActive";
import { useDownloadPublicBoard } from "~/hooks/useDownloadPublicBoard";
import { centralizedBoardIdSelector } from "~/store/centralizedBoard/selectors";
import { canGenerateZip } from "~/utils/permissions/taskPermissions";
export const PublicBoardBottomBar = /*#__PURE__*/ memo(()=>{
    const { permissions } = usePublicPermissions();
    const boardId = useSelector(centralizedBoardIdSelector);
    const { downloadPublicBoard } = useDownloadPublicBoard();
    const { isSearchActive } = useIsSearchActive();
    const isDownloadVisible = canGenerateZip(permissions) && !!boardId;
    const { isAboveMediumScreen } = useBreakpointsContext();
    const onDownloadClick = useCallback(()=>{
        if (boardId) {
            downloadPublicBoard({
                boardId,
                trackLocation: "board-stats-bar"
            });
        }
    }, [
        boardId,
        downloadPublicBoard
    ]);
    return /*#__PURE__*/ _jsxs(BoardBottombar, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center gap-2",
                children: [
                    /*#__PURE__*/ _jsx(Air, {
                        className: "w-[48px] text-black dark:text-white",
                        "data-testid": "BottomBarLogo"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "h-4 w-px bg-grey-8"
                    }),
                    /*#__PURE__*/ _jsx(PublicBoardStats, {})
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex items-center gap-2",
                children: !isSearchActive && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        isAboveMediumScreen && /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(ToggleNestedItemsButton, {}),
                                isDownloadVisible && /*#__PURE__*/ _jsx("div", {
                                    className: "h-4 w-px bg-grey-8"
                                })
                            ]
                        }),
                        isDownloadVisible && /*#__PURE__*/ _jsx(Tooltip, {
                            label: "Download board",
                            children: /*#__PURE__*/ _jsx(IconButton, {
                                appearance: "ghost",
                                color: "grey",
                                icon: Download,
                                label: "Download board",
                                onClick: onDownloadClick
                            })
                        })
                    ]
                })
            })
        ]
    });
});
PublicBoardBottomBar.displayName = "PublicBoardBottomBar";
